module.exports = __webpack_public_path__ + "static/media/Group 788.f970bdfd.svg";